import { ChangeDetectionStrategy, Component, input, InputSignal } from '@angular/core'
import { AbstractControl } from '@angular/forms'
import { TranslatePipe } from '@ngx-translate/core'
import { OrderTypeEnum } from '@modules/orders-module/enums/order-type.enum'
import { UseLocales } from '@modules/lang-module/decorators/use-locales'
import { SelectComponent } from '@shared/components/ui-kit/select/select.component'
import ru from './core/locale/ru.json'
import en from './core/locale/en.json'

@UseLocales({ ru, en })
@Component({
	selector: 'app-order-type-select',
	templateUrl: './order-type-select.component.html',
	styleUrl: './order-type-select.component.scss',
	changeDetection: ChangeDetectionStrategy.OnPush,
	imports: [TranslatePipe, SelectComponent],
})
export class OrderTypeSelectComponent {
	public control: InputSignal<AbstractControl | null> = input<AbstractControl | null>(null)
	public types: InputSignal<OrderTypeEnum[]> = input<OrderTypeEnum[]>([])
	public visibleLabel: InputSignal<boolean> = input<boolean>(true)
}
